<script setup lang="ts">
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import LandingTitleLayout from '../LandingTitleLayout.vue';
import { APP_NAME } from '@glow/shared/lib/constants';

const { staticUrl } = useRuntimeConfig().public;

onMounted(() => {
  gsap.registerPlugin(ScrollTrigger);
  gsap.set('.problems', { autoAlpha: 1 });

  const timeline = gsap.timeline({
    defaults: {
      overwrite: 'auto',
      ease: 'power1',
    },
    scrollTrigger: {
      end: '+=300%',
      pin: true,
      scrub: true,
      start: 'center center',
      trigger: '.problems',
    },
  });

  const stagger = 0.8;
  const duration = 1;

  gsap.set('.problems', { autoAlpha: 1 });

  timeline.set('.problems__item', { transformOrigin: 'center bottom' });

  timeline
    .from('.problems__item', {
      duration,
      opacity: 0,
      rotationX: 0,
      rotationY: 0,
      scale: 1,
      stagger,
      yPercent: 60,
    })
    .to(
      '.problems__item',
      {
        duration,
        opacity: 0,
        rotationX: 20,
        rotationY: 2,
        scale: 0.75,
        stagger,
        y: -100,
      },
      stagger
    );
});
</script>

<template>
  <div id="additional" class="problems">
    <LandingTitleLayout>
      <template #title>
        Забери от {{ APP_NAME }}
        <span>только лучшее</span>
      </template>
    </LandingTitleLayout>

    <div class="problems__grid container">
      <div class="problems__list">
        <div class="problems__item">
          <div class="problems__title">Пройдем все этапы с тобой</div>
          <div class="problems__text">
            Поможем зарегистрироваться и познакомим с сервисом. Любезно ответим
            на все вопросы
          </div>
        </div>
        <div class="problems__item">
          <div class="problems__title">Защита личных данных</div>
          <div class="problems__text">
            Не беспокойтесь. Конфиденциальная информация не передается третьим
            лицам
          </div>
        </div>
        <div class="problems__item">
          <div class="problems__title">Не отвлекайся от отдыха</div>
          <div class="problems__text">
            Клиенты записываются на услуги не отвлекая тебя от работы или отдыха
            дома
          </div>
        </div>
        <div class="problems__item">
          <div class="problems__title">Все в свои руки</div>
          <div class="problems__text">
            Записывайте клиента сами. Назначайте дату и время сеанса, а ему
            придет оповещение
          </div>
        </div>
        <div class="problems__item">
          <div class="problems__title">История записей</div>
          <div class="problems__text">
            Подробная информация по оказанной услуге — от используемых
            материалов до заметок мастера
          </div>
        </div>
      </div>

      <div class="d-flex justify-content-center align-items-start">
        <NuxtImg
          format="webp"
          :src="`${staticUrl}/landing/solve-problem.png`"
          class="problems__illustration"
          alt=""
        />
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.problems {
  &__grid {
    @include media-breakpoint-up(md) {
      display: grid;
      grid-template-columns: repeat(2, 1fr);
    }
  }

  &__illustration {
    max-width: 100%;
  }

  &__list {
    position: relative;
    width: 100%;
    height: 350px;
    @include media-breakpoint-down(md) {
      height: 200px;
    }
  }

  &__item {
    width: 100%;
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    padding: 28px 0 32px 0;
  }

  &__title {
    font-weight: 600;
    font-size: 22px;
    line-height: 28px;

    @include media-breakpoint-up(xl) {
      font-size: 28px;
      line-height: 35px;
    }
  }

  &__text {
    font-size: 17px;
    line-height: 22px;

    @include media-breakpoint-up(xl) {
      font-size: 22px;
      line-height: 28px;
    }
  }
}
</style>
